import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const FolderForm_Folder_Fragment = graphql(`
  fragment FolderForm_Folder_Fragment on Folder {
    # technical
    _id
    codingConfig {
      kind
      strategyId
      ... on CodingConfigManual {
        code
      }
      ...CodeCmp_CodingConfig_Fragment
    }

    # generalInfo
    title
    description
    internalMemo
    memo
    color
    businessCreatorId
    businessCreationDate
    workflowId
    isConfidential

    # actors
    internalActors {
      _id
      categoryIds
      index
      isInternal
      kind
      thirdPartyId
      typeId
      ... on ActorOrganization {
        ...ActorForm_RepresentativesDetailsStep_ActorOrganization_Fragment
        useItsEdmDomain
        references {
          _id
          typeId
          value
        }
        representatives {
          contextualRoleIds
          index
          personId
          typeIds
        }
      }
      ... on ActorPerson {
        contextualRoleIds
        references {
          _id
          typeId
          value
        }
      }
      ...ActorForm_Actor_Fragment
    }

    externalActors {
      _id
      categoryIds
      index
      isInternal
      kind
      thirdPartyId
      typeId
      ... on ActorOrganization {
        ...ActorForm_RepresentativesDetailsStep_ActorOrganization_Fragment
        useItsEdmDomain
        references {
          _id
          typeId
          value
        }
        representatives {
          contextualRoleIds
          index
          personId
          typeIds
        }
      }
      ... on ActorPerson {
        contextualRoleIds
        references {
          _id
          typeId
          value
        }
      }
      ...ActorForm_Actor_Fragment
    }

    # addresses
    address {
      _id
      typeIds
      postalInfo {
        _id
        postOfficeBox
        postalCode
        region
        route
        streetNumber
        additional
        building
        businessPostCode {
          postalCode
          distributorOfficeNumber
        }
        locality
        inseeCode
        department
        countryAlpha2
      }
      locationInfo {
        _id
        coordinates
        projectionId
        altitude
      }
      cadastralInfo {
        _id
        departmentCode
        districtCode
        municipalityCode
        number
        oldMunicipalityCode
        section
        sheet
      }
      ...AddressWithMapCmp_Address_Fragment
      ...AddressForm_Address_Fragment
    }

    # code
    code

    ...FolderBusinessEntityForm_GeneralInfoStep_FolderBusinessEntity_Fragment
    ...FolderBusinessEntityForm_CodingConfigStep_Codable_Fragment
  }
`);

export type FolderForm_Folder = ResultOf<typeof FolderForm_Folder_Fragment>;
